<div class="center">
	<p>Authentication is now complete.</p>
	<p>You may return to the application.</p>
</div>
